import { render, staticRenderFns } from "./GroupsTitle.vue?vue&type=template&id=04332870&scoped=true&"
import script from "./GroupsTitle.vue?vue&type=script&lang=js&"
export * from "./GroupsTitle.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTitle.vue?vue&type=style&index=0&id=04332870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04332870",
  null
  
)

export default component.exports